import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '../../components/ui';
import { intranetApi as api } from '../../services/intranet-api';

interface Area {
  area_id: string;
  name: string;
  code: string;
  description: string | null;
  role: 'viewer' | 'editor';
}

/**
 * Portale Intranet — lista aree tematiche assegnate all'utente.
 */
export function IntranetAreasPage() {
  const [areas, setAreas] = useState<Area[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadAreas = async () => {
      try {
        const response = await api.get<{ data: Area[] }>('/areas');
        setAreas(response.data.data);
      } catch {
        setAreas([]);
      } finally {
        setLoading(false);
      }
    };
    loadAreas();
  }, []);

  if (loading) return <LoadingSpinner />;

  if (areas.length === 0) {
    return (
      <div className="intranet-page">
        <div className="page-header">
          <h2>Intranet</h2>
        </div>
        <div className="empty-state">
          <p>Non hai accesso a nessuna area. Contatta l'amministratore.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="intranet-page">
      <div className="page-header">
        <h2>Intranet</h2>
        <span className="text-muted">{areas.length} {areas.length === 1 ? 'area' : 'aree'} disponibili</span>
      </div>

      <div className="intranet-areas-grid">
        {areas.map((area) => (
          <div
            key={area.area_id}
            className="intranet-area-card"
            onClick={() => navigate(`/portals/intranet/areas/${area.area_id}`)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate(`/portals/intranet/areas/${area.area_id}`)}
          >
            <div className="area-card-header">
              <h3>{area.name}</h3>
              <span className={`role-badge role-badge--${area.role}`}>
                {area.role === 'editor' ? '✏️ Editor' : '👁️ Viewer'}
              </span>
            </div>
            {area.description && (
              <p className="area-card-description">{area.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
